export default __webpack_public_path__ + "static/media/icon-repay.78acc3e0.svg";